export default "__VITE_ASSET__B$GX2dUr__"